export interface ICommand { }

export class AcceptWorkspaceInvitationCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Organizations.Workspaces.Commands.AcceptWorkspaceInvitationCommandV1, TCh.Domain.Organizations';

	Id: string;
	RecipientEmail: string;

	constructor (id: string, recipientEmail: string)
	{
		this.Id = id;
		this.RecipientEmail = recipientEmail;
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Organizations.Workspaces.Commands.AcceptWorkspaceInvitationCommandV1, TCh.Domain.Organizations'
	}

}

export class AddUserToWorkspaceCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Organizations.Workspaces.Commands.AddUserToWorkspaceCommandV1, TCh.Domain.Organizations';

	Id: string;
	UserId: string;

	constructor (id: string, userId: string)
	{
		this.Id = id;
		this.UserId = userId;
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Organizations.Workspaces.Commands.AddUserToWorkspaceCommandV1, TCh.Domain.Organizations'
	}

}

export class CreateWorkspaceCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Organizations.Workspaces.Commands.CreateWorkspaceCommandV1, TCh.Domain.Organizations';

	Id: string;
	OrganizationUnitId: number;
	Name: string;
	Description: string;
	StartupUrl: string;

	constructor (id: string, organizationUnitId: number, name: string, description: string, startupUrl: string)
	{
		this.Id = id;
		this.OrganizationUnitId = organizationUnitId;
		this.Name = name;
		this.Description = description;
		this.StartupUrl = startupUrl;
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Organizations.Workspaces.Commands.CreateWorkspaceCommandV1, TCh.Domain.Organizations'
	}

}

export class DeleteWorkspaceCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Organizations.Workspaces.Commands.DeleteWorkspaceCommandV1, TCh.Domain.Organizations';

	Id: string;

	constructor (id: string)
	{
		this.Id = id;
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Organizations.Workspaces.Commands.DeleteWorkspaceCommandV1, TCh.Domain.Organizations'
	}

}

export class ImportToWorkspaceCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Organizations.Workspaces.Commands.ImportToWorkspaceCommandV1, TCh.Domain.Organizations';

	Id: string;
	BlobId: string;

	constructor (id: string, blobId: string)
	{
		this.Id = id;
		this.BlobId = blobId;
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Organizations.Workspaces.Commands.ImportToWorkspaceCommandV1, TCh.Domain.Organizations'
	}

}

export class InviteToWorkspaceCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Organizations.Workspaces.Commands.InviteToWorkspaceCommandV1, TCh.Domain.Organizations';

	Id: string;
	RecipientEmail: string;

	constructor (id: string, recipientEmail: string)
	{
		this.Id = id;
		this.RecipientEmail = recipientEmail;
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Organizations.Workspaces.Commands.InviteToWorkspaceCommandV1, TCh.Domain.Organizations'
	}

}

export class RejectWorkspaceInvitationCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Organizations.Workspaces.Commands.RejectWorkspaceInvitationCommandV1, TCh.Domain.Organizations';

	Id: string;
	RecipientEmail: string;

	constructor (id: string, recipientEmail: string)
	{
		this.Id = id;
		this.RecipientEmail = recipientEmail;
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Organizations.Workspaces.Commands.RejectWorkspaceInvitationCommandV1, TCh.Domain.Organizations'
	}

}

export class RemoveUserFromWorkspaceCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Organizations.Workspaces.Commands.RemoveUserFromWorkspaceCommandV1, TCh.Domain.Organizations';

	Id: string;
	UserId: string;

	constructor (id: string, userId: string)
	{
		this.Id = id;
		this.UserId = userId;
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Organizations.Workspaces.Commands.RemoveUserFromWorkspaceCommandV1, TCh.Domain.Organizations'
	}

}

export class UpdateWorkspaceCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Organizations.Workspaces.Commands.UpdateWorkspaceCommandV1, TCh.Domain.Organizations';

	Id: string;
	Name: string;
	Description: string;
	StartupUrl: string;

	constructor (id: string, name: string, description: string, startupUrl: string)
	{
		this.Id = id;
		this.Name = name;
		this.Description = description;
		this.StartupUrl = startupUrl;
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Organizations.Workspaces.Commands.UpdateWorkspaceCommandV1, TCh.Domain.Organizations'
	}

}

